// Mock data for MealHoster - Meal Experiences Marketplace

export const categories = [
  { id: 1, name: 'Home Cooked', icon: 'Home' },
  { id: 2, name: 'Traditional', icon: 'Scroll' },
  { id: 3, name: 'Food Tour', icon: 'MapPin' },
  { id: 4, name: 'Aperitivo', icon: 'GlassWater' },
  { id: 5, name: 'Supper Club', icon: 'Fish' },
  { id: 6, name: 'Farm to Table', icon: 'Leaf' },
  { id: 7, name: 'Cooking Class', icon: 'ChefHat' },
  { id: 8, name: 'Drinks Journey', icon: 'GlassWater' },
  { id: 9, name: 'Street Food', icon: 'MapPin' },
  { id: 10, name: 'BBQ & Grill', icon: 'Flame' },
  { id: 11, name: 'Seafood', icon: 'Waves' },
  { id: 12, name: 'Vegan', icon: 'Salad' },
  { id: 13, name: 'Brunch', icon: 'Coffee' },
  { id: 14, name: 'Dessert', icon: 'Cake' },
  { id: 15, name: 'Private Chef', icon: 'UtensilsCrossed' },
];

export const amenities = [
  'Vegetarian Options', 'Vegan Options', 'Gluten-Free', 'Halal', 'Kosher',
  'Kids Menu', 'Wine Included', 'BYOB Allowed', 'Outdoor Seating', 'Private Room',
  'Wheelchair Accessible', 'Parking Available', 'Pet Friendly', 'Live Music',
  'Cooking Demo', 'Recipe Card Included', 'Take-Home Treats', 'Dietary Accommodations',
  'Farm Tour', 'Market Visit', 'Chef Interaction', 'Photo Opportunities'
];

export const cuisineTypes = [
  'Italian', 'Japanese', 'Mexican', 'French', 'Indian', 'Thai', 'Chinese',
  'Mediterranean', 'American', 'Korean', 'Vietnamese', 'Greek', 'Spanish',
  'Middle Eastern', 'Ethiopian', 'Peruvian', 'Caribbean', 'Fusion'
];

export const mockExperiences = [
  {
    id: '1',
    title: 'Authentic Italian Pasta Making Experience',
    description: 'Join Nonna Maria in her cozy kitchen for an unforgettable pasta-making journey. Learn the secrets of handmade tagliatelle, ravioli, and her famous bolognese sauce passed down through four generations. Includes a full meal with wine pairing and recipes to take home.',
    location: 'Brooklyn, New York',
    coordinates: { lat: 40.6782, lng: -73.9442 },
    price: 85,
    duration: '3 hours',
    images: [
      'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=800',
      'https://images.unsplash.com/photo-1551183053-bf91a1d81141?w=800',
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=800',
      'https://images.unsplash.com/photo-1481931098730-318b6f776db0?w=800'
    ],
    rating: 4.98,
    reviewCount: 234,
    host: { name: 'Maria', image: 'https://randomuser.me/api/portraits/women/65.jpg', superhost: true },
    maxGuests: 8,
    cuisine: 'Italian',
    mealType: 'Dinner',
    amenities: ['Vegetarian Options', 'Wine Included', 'Recipe Card Included', 'Cooking Demo', 'Take-Home Treats'],
    category: 'Cooking Class',
    reviews: [
      { id: 1, user: 'Sarah', avatar: 'https://randomuser.me/api/portraits/women/44.jpg', date: 'January 2026', rating: 5, comment: 'Maria is an absolute treasure! The pasta was incredible and I learned so much. Worth every penny.' },
      { id: 2, user: 'James', avatar: 'https://randomuser.me/api/portraits/men/32.jpg', date: 'December 2025', rating: 5, comment: 'Best culinary experience of my life. The stories, the food, the wine - perfection!' }
    ]
  },
  {
    id: '2',
    title: 'Exclusive Supper Club at Hidden Sushi Bar',
    description: 'Experience a 15-course omakase dinner at an intimate 8-seat counter. Chef Tanaka sources the freshest fish daily from Tsukiji market connections. Watch master knife work up close while savoring rare cuts and seasonal specialties.',
    location: 'Los Angeles, California',
    coordinates: { lat: 34.0522, lng: -118.2437 },
    price: 275,
    duration: '2.5 hours',
    images: [
      'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?w=800',
      'https://images.unsplash.com/photo-1553621042-f6e147245754?w=800',
      'https://images.unsplash.com/photo-1617196034796-73dfa7b1fd56?w=800',
      'https://images.unsplash.com/photo-1582450871972-ab5ca641643d?w=800'
    ],
    rating: 4.99,
    reviewCount: 89,
    host: { name: 'Chef Tanaka', image: 'https://randomuser.me/api/portraits/men/45.jpg', superhost: true },
    maxGuests: 8,
    cuisine: 'Japanese',
    mealType: 'Dinner',
    amenities: ['Gluten-Free', 'Chef Interaction', 'Photo Opportunities', 'Private Room'],
    category: 'Supper Club',
    reviews: [
      { id: 1, user: 'Michael', avatar: 'https://randomuser.me/api/portraits/men/22.jpg', date: 'January 2026', rating: 5, comment: 'The best sushi I\'ve ever had. Chef Tanaka is a true master. The uni was life-changing.' }
    ]
  },
  {
    id: '3',
    title: 'Celebrity Chef Gordon\'s Pop-Up Dinner',
    description: 'A once-in-a-lifetime dining experience with Michelin-starred Chef Gordon Blake. Enjoy a 7-course tasting menu featuring his signature dishes with personal stories behind each creation. Limited to 20 guests per evening.',
    location: 'Manhattan, New York',
    coordinates: { lat: 40.7831, lng: -73.9712 },
    price: 450,
    duration: '4 hours',
    images: [
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800',
      'https://images.unsplash.com/photo-1559339352-11d035aa65de?w=800',
      'https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?w=800',
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800'
    ],
    rating: 5.0,
    reviewCount: 56,
    host: { name: 'Chef Gordon Blake', image: 'https://randomuser.me/api/portraits/men/52.jpg', superhost: true },
    maxGuests: 20,
    cuisine: 'French',
    mealType: 'Dinner',
    amenities: ['Wine Included', 'Vegetarian Options', 'Chef Interaction', 'Private Room', 'Photo Opportunities'],
    category: 'Celebrity Chef',
    reviews: [
      { id: 1, user: 'Emily', avatar: 'https://randomuser.me/api/portraits/women/28.jpg', date: 'January 2026', rating: 5, comment: 'Absolutely spectacular. Chef Blake is not only talented but incredibly personable. A night I\'ll never forget.' }
    ]
  },
  {
    id: '4',
    title: 'Traditional Mexican Feast in Oaxacan Home',
    description: 'Step into Abuela Rosa\'s adobe kitchen for an authentic Oaxacan culinary journey. Learn to make mole negro from scratch, hand-press tortillas, and discover the ancient art of mezcal pairing. A true farm-to-table experience.',
    location: 'San Diego, California',
    coordinates: { lat: 32.7157, lng: -117.1611 },
    price: 95,
    duration: '4 hours',
    images: [
      'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=800',
      'https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?w=800',
      'https://images.unsplash.com/photo-1599974579688-8dbdd335c77f?w=800',
      'https://images.unsplash.com/photo-1534352956036-cd81e27dd615?w=800'
    ],
    rating: 4.97,
    reviewCount: 312,
    host: { name: 'Rosa', image: 'https://randomuser.me/api/portraits/women/55.jpg', superhost: true },
    maxGuests: 10,
    cuisine: 'Mexican',
    mealType: 'Lunch',
    amenities: ['Vegetarian Options', 'Vegan Options', 'Cooking Demo', 'Recipe Card Included', 'Farm Tour'],
    category: 'Traditional',
    reviews: [
      { id: 1, user: 'David', avatar: 'https://randomuser.me/api/portraits/men/67.jpg', date: 'December 2025', rating: 5, comment: 'Rosa is a national treasure. The mole was the best I\'ve ever had, and the stories were just as rich.' }
    ]
  },
  {
    id: '5',
    title: 'Farm-to-Table Dinner Under the Stars',
    description: 'Dine at a long communal table set in the middle of an organic farm. Chef Marcus creates a seasonal 5-course menu using ingredients harvested just hours before. Includes farm tour, bonfire, and live acoustic music.',
    location: 'Napa Valley, California',
    coordinates: { lat: 38.2975, lng: -122.2869 },
    price: 185,
    duration: '5 hours',
    images: [
      'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800',
      'https://images.unsplash.com/photo-1515003197210-e0cd71810b5f?w=800',
      'https://images.unsplash.com/photo-1560493676-04071c5f467b?w=800',
      'https://images.unsplash.com/photo-1506368249639-73a05d6f6488?w=800'
    ],
    rating: 4.96,
    reviewCount: 178,
    host: { name: 'Chef Marcus', image: 'https://randomuser.me/api/portraits/men/35.jpg', superhost: true },
    maxGuests: 30,
    cuisine: 'American',
    mealType: 'Dinner',
    amenities: ['Vegetarian Options', 'Vegan Options', 'Wine Included', 'Outdoor Seating', 'Farm Tour', 'Live Music'],
    category: 'Farm to Table',
    reviews: [
      { id: 1, user: 'Jennifer', avatar: 'https://randomuser.me/api/portraits/women/48.jpg', date: 'January 2026', rating: 5, comment: 'Magical evening! The setting was breathtaking and every dish told the story of the land.' }
    ]
  },
  {
    id: '6',
    title: 'Underground Supper Club Experience',
    description: 'Join our secret supper club at a hidden location revealed 24 hours before. International fusion cuisine, craft cocktails, and fascinating company. Each month features a different theme and mystery location.',
    location: 'Chicago, Illinois',
    coordinates: { lat: 41.8781, lng: -87.6298 },
    price: 125,
    duration: '3.5 hours',
    images: [
      'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800',
      'https://images.unsplash.com/photo-1485686531765-ba63b07845a7?w=800',
      'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=800',
      'https://images.unsplash.com/photo-1496412705862-e0088f16f791?w=800'
    ],
    rating: 4.94,
    reviewCount: 267,
    host: { name: 'The Collective', image: 'https://randomuser.me/api/portraits/men/29.jpg', superhost: true },
    maxGuests: 40,
    cuisine: 'Fusion',
    mealType: 'Dinner',
    amenities: ['Wine Included', 'Vegetarian Options', 'Private Room', 'Live Music'],
    category: 'Fine Dining',
    reviews: [
      { id: 1, user: 'Alex', avatar: 'https://randomuser.me/api/portraits/men/41.jpg', date: 'December 2025', rating: 5, comment: 'The mystery and anticipation made it even more special. Incredible food and met amazing people!' }
    ]
  },
  {
    id: '7',
    title: 'Thai Street Food Walking Tour & Feast',
    description: 'Explore authentic Thai street food with Chef Siri as your guide. Visit 6 hidden stalls, learn to identify authentic flavors, and end at her home kitchen for a cooking demo of pad thai and som tam.',
    location: 'San Francisco, California',
    coordinates: { lat: 37.7749, lng: -122.4194 },
    price: 75,
    duration: '4 hours',
    images: [
      'https://images.unsplash.com/photo-1562565652-a0d8f0c59eb4?w=800',
      'https://images.unsplash.com/photo-1559314809-0d155014e29e?w=800',
      'https://images.unsplash.com/photo-1569562211093-4ed0d0758f12?w=800',
      'https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?w=800'
    ],
    rating: 4.95,
    reviewCount: 445,
    host: { name: 'Siri', image: 'https://randomuser.me/api/portraits/women/39.jpg', superhost: true },
    maxGuests: 12,
    cuisine: 'Thai',
    mealType: 'Lunch',
    amenities: ['Vegetarian Options', 'Vegan Options', 'Cooking Demo', 'Market Visit', 'Recipe Card Included'],
    category: 'Street Food',
    reviews: [
      { id: 1, user: 'Rachel', avatar: 'https://randomuser.me/api/portraits/women/33.jpg', date: 'January 2026', rating: 5, comment: 'Siri knows every hidden gem! My taste buds went on an adventure. Best food tour ever!' }
    ]
  },
  {
    id: '8',
    title: 'Texas BBQ Masterclass with Pitmaster Joe',
    description: 'Spend a day learning low-and-slow smoking techniques from award-winning pitmaster Joe. Includes brisket, ribs, and all the fixings. Take home smoked meats and your own custom spice rub blend.',
    location: 'Austin, Texas',
    coordinates: { lat: 30.2672, lng: -97.7431 },
    price: 150,
    duration: '6 hours',
    images: [
      'https://images.unsplash.com/photo-1529193591184-b1d58069ecdd?w=800',
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=800',
      'https://images.unsplash.com/photo-1558030006-450675393462?w=800',
      'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800'
    ],
    rating: 4.99,
    reviewCount: 198,
    host: { name: 'Pitmaster Joe', image: 'https://randomuser.me/api/portraits/men/58.jpg', superhost: true },
    maxGuests: 15,
    cuisine: 'American',
    mealType: 'Lunch',
    amenities: ['Gluten-Free', 'Cooking Demo', 'Take-Home Treats', 'Outdoor Seating', 'Parking Available'],
    category: 'BBQ & Grill',
    reviews: [
      { id: 1, user: 'Tom', avatar: 'https://randomuser.me/api/portraits/men/72.jpg', date: 'December 2025', rating: 5, comment: 'Joe is a legend! Learned so much and the brisket was out of this world. Worth the trip to Austin.' }
    ]
  },
  {
    id: '9',
    title: 'Champagne Brunch at Private Rooftop Garden',
    description: 'Indulge in an elegant 4-course brunch overlooking the city skyline. Features house-made pastries, eggs benedict variations, fresh seafood, and bottomless champagne. Live jazz accompaniment.',
    location: 'Miami, Florida',
    coordinates: { lat: 25.7617, lng: -80.1918 },
    price: 120,
    duration: '3 hours',
    images: [
      'https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?w=800',
      'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=800',
      'https://images.unsplash.com/photo-1533089860892-a7c6f0a88666?w=800',
      'https://images.unsplash.com/photo-1482049016gy643f2aab9?w=800'
    ],
    rating: 4.93,
    reviewCount: 156,
    host: { name: 'Chef Amelie', image: 'https://randomuser.me/api/portraits/women/72.jpg', superhost: true },
    maxGuests: 24,
    cuisine: 'French',
    mealType: 'Brunch',
    amenities: ['Vegetarian Options', 'Gluten-Free', 'Wine Included', 'Outdoor Seating', 'Live Music', 'Photo Opportunities'],
    category: 'Brunch',
    reviews: [
      { id: 1, user: 'Sophie', avatar: 'https://randomuser.me/api/portraits/women/22.jpg', date: 'January 2026', rating: 5, comment: 'The most glamorous brunch of my life! Views, food, champagne - all perfect.' }
    ]
  },
  {
    id: '10',
    title: 'Vegan Food Challenge by Plant Pioneer',
    description: 'Experience how plants can create pure magic. Chef Luna presents a 9-course vegan tasting menu that will change how you think about plant-based cuisine. Includes juice pairings and chocolate truffles.',
    location: 'Portland, Oregon',
    coordinates: { lat: 45.5152, lng: -122.6784 },
    price: 145,
    duration: '3 hours',
    images: [
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800',
      'https://images.unsplash.com/photo-1540914124281-342587941389?w=800',
      'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=800',
      'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800'
    ],
    rating: 4.97,
    reviewCount: 203,
    host: { name: 'Chef Luna', image: 'https://randomuser.me/api/portraits/women/68.jpg', superhost: true },
    maxGuests: 16,
    cuisine: 'Fusion',
    mealType: 'Dinner',
    amenities: ['Vegan Options', 'Gluten-Free', 'Dietary Accommodations', 'Chef Interaction', 'Recipe Card Included'],
    category: 'Vegan',
    reviews: [
      { id: 1, user: 'Chris', avatar: 'https://randomuser.me/api/portraits/men/36.jpg', date: 'December 2025', rating: 5, comment: 'I\'m not even vegan and this was one of the best meals of my life. Chef Luna is a genius!' }
    ]
  }
];

export const mockBookings = [
  {
    id: '1',
    experienceId: '1',
    guestName: 'John Doe',
    date: '2026-02-15',
    guests: 4,
    totalPrice: 340,
    status: 'confirmed'
  },
  {
    id: '2',
    experienceId: '3',
    guestName: 'Jane Smith',
    date: '2026-02-22',
    guests: 2,
    totalPrice: 900,
    status: 'pending'
  }
];

// Keep backward compatibility
export const mockProperties = mockExperiences;
